import React, { useState } from 'react';
import cx from 'classnames';
import { Dropdown } from 'antd';
import { MoreHorizontal as More } from 'lucide-react';
import ColumnName from './column_name/ColumnName';
import styles from './index.module.css';
import { ARCHIVE_STAGE_INITIAL } from './types';
import { useDispatch } from 'react-redux';
import { menuItems } from './MenuItems';

type Props = {
  column: any;
  getColumnToDelete: (columnId: number) => void;
  toggleDeleteModal: () => void;
  toggleArchiveModal: () => void;
  getArchive: (tasksToArchive: any, columnId: any) => void;
  canManageColumn: boolean;
  isPlaceholder: boolean;
  archiveAllowed: boolean;
  cards: any[];
  updateColumnName: (columnId: number, name: string) => void;
  isMinColumns: boolean;
  unfilteredTaskCount: number;
  dragHandleProps: any;
  projectId: number;
  columnPosition: number;
  insertFieldForNewColumn: (columnPosition: number) => void;
};

const ColumnHeader: React.FC<Props> = ({
  column,
  getColumnToDelete,
  toggleDeleteModal,
  toggleArchiveModal,
  getArchive,
  canManageColumn,
  isPlaceholder,
  archiveAllowed,
  cards,
  updateColumnName,
  isMinColumns,
  unfilteredTaskCount,
  dragHandleProps,
  projectId,
  columnPosition,
  insertFieldForNewColumn
}) => {
  const [showEditName, setShowEditName] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [archiveStage, setArchiveStage] = useState(ARCHIVE_STAGE_INITIAL);
  const dispatch = useDispatch();

  const hideEditMode = () => setShowEditName(false);
  const showEditMode = () => canManageColumn && setShowEditName(true);

  const handleColumnNameSave = tempName => {
    updateColumnName(column.id, tempName);
    hideEditMode();
  };

  const setIsMenuOpenWrapper = flag => {
    setIsMenuOpen(flag);
    setArchiveStage(flag ? ARCHIVE_STAGE_INITIAL : archiveStage);
  };

  const enableDropDownMenu = canManageColumn;
  const archiveDisabled = cards.length < 1;

  // hide unread comments open for the moment
  const unreadCommentsAllowed = false;
  return (
    <div
      className={cx({
        [styles.columnHeader]: true,
        [styles.redHeader]: column.color === 'red',
        [styles.blueHeader]: column.color === 'blue',
        [styles.greenHeader]: column.color === 'green',
        [styles.orangeHeader]: column.color === 'orange',
        [styles.whiteHeader]: column.color === 'white' || column.color === null,
        [styles.draggableHeader]: !showEditName && canManageColumn,
        ['dragHandler']: !showEditName,
        [styles.dummyHeader]: isPlaceholder
      })}
      {...dragHandleProps}
    >
      {!canManageColumn || !showEditName ? (
        <div className={styles.columnHeaderInfo}>
          <div onClick={showEditMode} className={styles.columnNameDisplay}>
            {column.name}
          </div>
          <div className={styles.columnCount}>
            <span className={styles.countInner}>{column.children.length}</span>
          </div>
        </div>
      ) : (
        <ColumnName
          onCancel={hideEditMode}
          onSave={handleColumnNameSave}
          value={column.name}
          color={column.color}
        />
      )}
      {enableDropDownMenu && (
        <Dropdown
          className={styles.moreDropdown}
          trigger={['click']}
          placement="bottomLeft"
          getPopupContainer={() =>
            document.getElementById('kanbanBoard') as HTMLElement
          }
          onOpenChange={setIsMenuOpenWrapper}
          open={isMenuOpen}
          menu={{
            items: menuItems({
              isMinColumns,
              unfilteredTaskCount,
              getArchive,
              handleAddColumn: () => insertFieldForNewColumn(columnPosition),
              dispatch,
              showEditMode,
              cards,
              projectId,
              column,
              toggleArchiveModal,
              toggleDeleteModal,
              getColumnToDelete,
              archiveDisabled,
              archiveAllowed,
              unreadCommentsAllowed,
              archiveStage
            })
          }}
        >
          <More
            className={cx({
              [styles.columnIcon]: true,
              [styles.whiteStrokeColor]:
                column.color !== 'white' && column.color !== null
            })}
            data-cy="columnIcon"
          />
        </Dropdown>
      )}
    </div>
  );
};
export default ColumnHeader;
